import { fileURLToPath } from 'node:url';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../Environment/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserManagementService {

  constructor(private http: HttpClient) { }

  // ---------------------- Get users List API ---------------------- //

  getAllUserList(api: string) {
    return this.http.get(environment.baseUrl + api)
  }

  // ---------------------- Post Approve/Reject Users API ---------------------- //

  postApproveReject(api: string, userId: any, status: boolean): Observable<any> {
    const url = `${environment.baseUrl}${api}?userId=${userId}&status=${status}`;
    return this.http.post<any>(url, {});
  }

  // ---------------------- Get users List API ---------------------- //

  getUserList(api: string, userTypeId: number) {
    const url = `${environment.baseUrl}${api}?userTypeId=${userTypeId}`
    return this.http.get(url)
  }

  // ---------------------- Active & Inactive Users API ---------------------- //

  postActiveInactiveUser(api: string, userId: any, status: boolean) {
    const url = `${environment.baseUrl}${api}?UserId=${userId}&status=${status}`
    return this.http.post(url, '')
  }

  // ---------------------- Get User On & Off business API ---------------------- //

  getOnOffBuisness(api: string,
    userTypeId: any = null,
    cityId: any = null,
    zoneId: any = null,) {

    let params: string = "";

    if (cityId) {
      params += params ? `&city=${cityId}` : `?city=${cityId}`;
    }
    if (zoneId) {
      params += params ? `&zone=${zoneId}` : `?zone=${zoneId}`;
    }
    if (userTypeId) {
      params += params ? `&userType=${userTypeId}` : `?userType=${userTypeId}`;
    }

    const url = `${environment.baseUrl}${api}${params}`
    return this.http.get(url);

  }

  // crVatDownload(api: string, userId: any, docType: any) {
  //   const url = `${environment.baseUrl}${api}?userId=${userId}&DocType=${docType}`;
  //   return this.http.get(url, { observe:"response", responseType: "blob"});
  // }

  crVatDownload(api: string, userId: any, docType: any) {
    const url = `${environment.baseUrl}${api}?userId=${userId}&DocType=${docType}`;
    
    // Define headers with the expected file formats
    const headers = new HttpHeaders({
      Accept: 'application/pdf, image/png, image/jpeg, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/octet-stream'
    });
  
    return this.http.get(url, { headers, observe: 'response', responseType: 'blob' });
  }
  

  // ---------------------- Get container details API ---------------------- //

  getContainerDetails(api: string, userId: any) {
    const url = `${environment.baseUrl}${api}?UserId=${userId}`
    return this.http.get(url);
  }
}
